const config = {
    defaultCurrency: 'USD',
    defaultLocale: 'en-US',
    defaultLanguage: {
        code: 'en',
        name: 'English',
        primaryCountryIsoCode: 'us', // For associating flags w/lang
    },
    supportedLocales: [
        'de-de',
        'en-ca',
        'en-gb',
        'en-us',
        'es-es',
        'es-mx',
        'fr-ca',
        'fr-fr',
        'it-it',
        'nl-nl',
    ],
};

module.exports = config;
